import React from 'react'
import MediaDrawer from '../MediaDrawer'
import MediaCarousel from '../MediaCarousel'
import Button from '@bt-react/components/Button'
import { IconType } from '@bt-react/components/Icon'
import { PlayInDrawerProps } from './types'
import VideoCard from '../VideoCard'

const PlayInDrawer: React.FC<PlayInDrawerProps> = (props) => {

  const getSelectedItem: number | undefined = (props?.items ?? []).findIndex( playIn => {

      return props.playIn  && props.playIn.isFocused() && playIn.sources.length &&
        props.playIn.doc?.sources?.includes(playIn.sources?.[0].src)
    }
  )

  const items = (props?.items ?? []).map((playIn, i) =>
    <VideoCard
      key={i + playIn.title}
      title={playIn.title}
      image={playIn.previewImage}
      duration={playIn.duration}
      onClick={() => props.onVideoClick && props.onVideoClick(playIn, props.presenterLayoutActive)}
      selected={i === props.selected}
    />
  )

  return <MediaDrawer
    title='Video list'
    onClick={props.onClick}
    dataBdd='play-in'
    hidden={typeof props.hidden === 'boolean' ? props.hidden : true}
    action={
      props.showPlayInModal
        ? <Button
          color={IconType.colour.secondary}
          onClick={props.showPlayInModal}
          text='Add and manage video'
          dataBdd='play-in-add-manage-btn'
        />
        : <></>
    }
  >
    <MediaCarousel
      empty={{
        icon: IconType.iconName.playOutline,
        message: 'No videos added'
      }}
      items={items}
      selected={getSelectedItem}
    />
  </MediaDrawer>

}

export default PlayInDrawer
